import { render, staticRenderFns } from "./CalculatorIpoteka.vue?vue&type=template&id=132aef7c&scoped=true&"
import script from "./CalculatorIpoteka.vue?vue&type=script&lang=js&"
export * from "./CalculatorIpoteka.vue?vue&type=script&lang=js&"
import style0 from "./CalculatorIpoteka.vue?vue&type=style&index=0&id=132aef7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132aef7c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CalcOfIpoteka: require('/var/www/k9-frontend/k9-front-20261006142511/components/calc-block/CalcOfIpoteka.vue').default})
